import { useMutation, useQueryClient } from 'react-query'

import { type ExpenseUseCaseErrors } from '@webapp/modules/expense/business-logic/use-cases/ExpenseUseCaseErrors'
import { submitExpenseReportUseCase } from '@webapp/modules/expense/business-logic/use-cases/SubmitExpenseReport'
import { type ExpenseReportFormSchema } from '@webapp/modules/expense/components/CreateExpenseReportForm'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

interface MutateSubmitVariables {
  formValues: ExpenseReportFormSchema
  shouldSkipBudgetCheck: boolean
}

export const useMutateSubmitExpenseReport = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    { id: number; selfApproved: boolean },
    ExpenseUseCaseErrors,
    MutateSubmitVariables
  >({
    mutationFn: ({ formValues, shouldSkipBudgetCheck }) =>
      submitExpenseReportUseCase.execute({ formValues, shouldSkipBudgetCheck }),

    onSuccess: () => {
      queryClient.invalidateQueries(expenseQueryConfig.drafts().queryKey)
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
